























import { Vue, Component, Prop } from 'vue-property-decorator'
import { Blog } from '@/models/blog'
import { IDialog } from '@/models/dialog'
import { BlogCategory } from '@/models/blog-category'
import { SocialMediaPlatform } from '@/models/social-media-platform'
import { FacebookHelper } from '@/helpers/facebook-helper'

@Component
export default class ShareDialog extends Vue implements IDialog {
  @Prop() blog!: Blog
  private dialogOpen = false

  get thumbnailCategory () {
    switch (this.blog.category) {
      case BlogCategory.HtmlCss:
        return this.tagNames.includes('HTML') ? 'html' : 'css'
      case BlogCategory.Python:
        return 'python'
      case BlogCategory.JavaScript:
        return 'javascript'
      case BlogCategory.CSharp:
        return 'csharp'
      case BlogCategory.General:
        return 'general'
    }
  }

  get tagNames () {
    return this.blog.tags.map((tag) => tag.name)
  }

  toggle (open: boolean) {
    const dialog = document.getElementById('modal')
    if (dialog) {
      if (open) {
        dialog.classList.add('is-active')
      }
      else {
        dialog.classList.remove('is-active')
      }
    }
  }

  generateShareLink (platform: SocialMediaPlatform) {
    if (platform === SocialMediaPlatform.Facebook) {
      FacebookHelper.generateLink()
    }
  }
}
